export const getFontNameFromGoogleFontUrl = (fontUrl) => {
  const regExp = /(?:\?family=)([\w\d+]+)/g;
  const matches = regExp.exec(fontUrl);
  return matches[1].replace(/\+/g, ' ');
};

export default getFontNameFromGoogleFontUrl;
